module.exports = __webpack_public_path__ + "res/img/avatatr_no.7038a4de.png";